import { render, staticRenderFns } from "./select-customer.vue?vue&type=template&id=23eb3d66&scoped=true&"
import script from "./select-customer.vue?vue&type=script&lang=js&"
export * from "./select-customer.vue?vue&type=script&lang=js&"
import style0 from "./select-customer.vue?vue&type=style&index=0&id=23eb3d66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eb3d66",
  null
  
)

export default component.exports